import WeakSet from '.WeakSet';
import has from '.WeakSet.prototype.has';
import add from '.WeakSet.prototype.add';

const arrays = new WeakSet       ();
const arrays_add = /*#__PURE__*/add.bind(arrays);
export const isArray = /*#__PURE__*/has.bind(arrays)                                  ;

export const OF_TABLES = false;
export const STATICALLY = true;
const staticalArrays = new WeakSet       ();
const staticalArrays_add = /*#__PURE__*/add.bind(staticalArrays);
export const isStatic = /*#__PURE__*/has.bind(staticalArrays)                             ;

export const newArray = (isStatic         )        => {
	const array        = [];
	arrays_add(array);
	isStatic && staticalArrays_add(array);
	return array;
};

                                 
	                  
	              
 
